import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { toggleAnimation } from 'src/app/shared/animations';
import { Store } from '@ngrx/store';
import { AnalitycsService } from 'src/app/shared/service/analitycs.service';

@Component({
  selector: 'app-profile',
  animations: [toggleAnimation],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.css',
})
export class ProfileComponent {
  isDarkMode = false;
  store: any;
  selectedAvatar: string | null = null;
  selectedVehicle: string | null = null;

  constructor(
    private router: Router,
    private storeData: Store<any>,
    private analitycs: AnalitycsService,
  ) {
    localStorage.setItem('light', 'dark');
    this.storeData
      .select((state) => state.index.theme)
      .subscribe((theme) => {
        this.isDarkMode = theme === 'dark';
      });
  }
  ngOnInit() {
    this.analitycs.logEvent('el_usuario_ingresa_a_perfil', {
      pantalla: 'perfil',
      accion: 'clic',
      plataforma: 'web',
      timestamp: new Date().toISOString(),
    });
    this.selectedAvatar = localStorage.getItem('selectedAvatar') ?? 'assets/images/juan2.png';
    // const storedAvatar = localStorage.getItem('selectedAvatar'); // Obtiene el avatar guardado
    // if (storedAvatar) {
    //   this.selectedAvatar = storedAvatar; // Si existe, se lo asignamos
    // } else {
    //   this.selectedAvatar = 'assets/images/juan1.png'; // Opción predeterminada (Juan)
    // }
  }

  goToEditProfile() {
    this.analitycs.logEvent('ir_a_editar_perfil', {
      pantalla: 'perfil',
      accion: 'clic',
      plataforma: 'web',
      timestamp: new Date().toISOString(),
    });

    this.router.navigate(['/edit-profile']);
  }
  goBack() {
    this.analitycs.logEvent('ir_a_perfil', {
      pantalla: 'perfil',
      accion: 'clic',
      plataforma: 'web',
      timestamp: new Date().toISOString(),
    });
    this.router.navigate(['/']);
  }
  //   selectVehicle(vehicleId: string) {
  //     this.selectedVehicle = vehicleId;
  //   }
  //   closeModal() {
  //     this.selectedVehicle = null;
  //   }
}
